import moment from "moment-timezone";
import merge from "lodash/merge";
import isObject from "lodash/isObject";
import { isPort } from "@/utils/gkmgPortMaster";

export default {
  selectedDateFormatted: (state) => {
    moment.locale("ja");
    if (!state.selectedDate) return "";
    return moment(state.selectedDate.replace("/", "-"))
      .local()
      .format("YYYY/MM/DD(ddd)");
  },
  selectedDate: (state) => {
    return state.selectedDate;
  },
  storedFilterRule: (state) => {
    return state.storedFilterRule;
  },
  lastUpdatedForTasks: (state) => {
    return state.lastUpdatedForTasks;
  },
  presentColumnsFilteringState: (state) => {
    return state.presentColumnsFilteringState;
  },
  // masterMap から導いたフィルタの初期値
  initialFilterRule: (state) => {
    if (!isObject(state.masterMap)) return {};
    if (!Array.isArray(state.masterMap.ports)) return {};
    const { ports } = state.masterMap;
    const filterRule = ports
      .filter((port) => isPort(port))
      .reduce(
        (acc, port) => {
          const { id } = port;
          acc.port_id[id] = true;
          return acc;
        },
        {
          port_id: {},
        },
      );

    return filterRule;
    //   {
    //     "port_id": {
    //        [key: `${port_id}`]: true; // 初期値は全てtrue
    //     }
    //   }
  },
  // 画面に適用するフィルタ
  // 画面で選択したfilterの状態と、  masterMap から導いたフィルタの初期値をマージしたもの
  filterRuleMerged: (state, getters) => {
    const { storedFilterRule } = state;
    const { initialFilterRule } = getters;
    return merge({}, initialFilterRule, storedFilterRule); // deep merge
    // 現時点では画面上フィルタは 島(island_id) にあるが、実質 port_id によるフィルタとなる
    //   {
    //     "port_id": {
    //        [key: `${port_id}`]: boolean;
    //     }
    //   }
  },
  lastUpdatedTime: (state) => {
    moment.locale("ja");
    const date = state.selectedDate.replaceAll("/", "");
    const timeSecond = state.lastUpdatedTimeMap[date]
      ? Math.max(0, ...state.lastUpdatedTimeMap[date])
      : 0;
    const latestUpdatedAt = timeSecond
      ? moment(timeSecond * 1000)
          .local()
          .format("YYYY/MM/DD HH:mm")
      : "";

    return latestUpdatedAt;
  },
  // 進捗のマスタデータ
  progressMaster: (state) => {
    const { masterMap } = state;
    if (!isObject(masterMap)) return {};
    if (!isObject(masterMap.progress)) return {};
    return masterMap.progress;
  },
};
